export const isElectronRuntime = () =>
  typeof window !== 'undefined' && window.electron?.isElectron === true;
